import React from 'react';

import EmptyImage from 'static/empty.svg';

import Container from './elements';

const EmptyLayout = () => (
  <Container>
    <img src={EmptyImage} alt="Vacio" />
    <p>
      No hay un reporte de inventario abierto o locaciones abiertas
      <br />
      Contacta a un administrador
    </p>
  </Container>
);

export default EmptyLayout;
